import './section.scss';
import Component from '../component/component';

export default class Section extends Component {

    static initSelector: string = '.section';

    element: JQuery;
    scrollToTopButton: JQuery;

    constructor(target: HTMLElement) {
        super(target);

        this.scrollToTopButton = this.element.find('.js-section-scroll-to-top');

        this.init();
    }

    init(): void {
        this.scrollToTopButton.on('click', (event: JQuery.Event) => {
            event.preventDefault();
            $('html, body').animate({ scrollTop: 0 }, 500);
        });
    }
}
